export default __webpack_public_path__ + "static/media/Size5.607944a3.png";